import type { BranchKey } from '@festina-life/api'
import { assertNotEmpty } from '@festina-life/core'

import { useConciseBranch } from '../../../uiModels/branches/useConciseBranch'
import type { BranchStatus } from '../types'

export const useBaseBranchStatus = (branch: BranchKey): BranchStatus => {
  const currentConciseBranch = useConciseBranch({
    server: branch.server,
    branchName: branch.name,
    shouldFallbackToStandard: true,
  })

  const baseConciseBranch = useConciseBranch({
    server: branch.server,
    branchName: currentConciseBranch?.baseBranchName,
    shouldFallbackToStandard: false,
  })

  assertNotEmpty(currentConciseBranch)

  const areChangesetsInSync =
    baseConciseBranch?.currentChangesetKey ===
    currentConciseBranch?.baseChangesetKey

  const hasOwnTypesVersion = !currentConciseBranch.typesVersionIds?.length
  const currentTypesAreBasedOnBaseBranchTypes =
    currentConciseBranch.baseTypesVersionIds?.[0]?.typesVersionId ===
    baseConciseBranch?.typesVersionIds?.[0]?.typesVersionId
  const currentTypesAreBasedOnBaseBranchBaseTypes =
    !baseConciseBranch?.typesVersionIds?.[0]?.typesVersionId &&
    currentConciseBranch.baseTypesVersionIds?.[0]?.typesVersionId ===
      baseConciseBranch?.baseTypesVersionIds?.[0]?.typesVersionId

  const areTypeVersionsInSync =
    currentConciseBranch &&
    (hasOwnTypesVersion ||
      currentTypesAreBasedOnBaseBranchTypes ||
      currentTypesAreBasedOnBaseBranchBaseTypes)

  return currentConciseBranch &&
    (!currentConciseBranch.baseBranchName ||
      (areChangesetsInSync && areTypeVersionsInSync))
    ? 'inSync'
    : 'outOfSync'
}
